import {createBrowserHistory} from "history";

export default createBrowserHistory();
//history for logout
